module.exports = __webpack_public_path__ + "Flag-716.8865ff4e98cb2ba9f3253d4a3652d832.svg";